import { useState, useEffect, useCallback } from 'react';
import { ROTATION_INTERVAL, TRANSITION_DURATION } from '../constants/text';

interface UseRotatingTextProps {
  texts: readonly string[];
  onTransitionStart?: () => void;
  onTransitionEnd?: () => void;
}

export function useRotatingText({ 
  texts,
  onTransitionStart,
  onTransitionEnd
}: UseRotatingTextProps) {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState(texts[0]);
  const [isAnimating, setIsAnimating] = useState(false);

  const rotateText = useCallback(() => {
    setIsAnimating(true);
    onTransitionStart?.();

    setTimeout(() => {
      setIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % texts.length;
        setText(texts[newIndex]);
        return newIndex;
      });
      setIsAnimating(false);
      onTransitionEnd?.();
    }, TRANSITION_DURATION);
  }, [texts, onTransitionStart, onTransitionEnd]);

  useEffect(() => {
    const interval = setInterval(rotateText, ROTATION_INTERVAL);
    return () => clearInterval(interval);
  }, [rotateText]);

  return { text, index, isAnimating };
}